<i18n src="@/locales/components/RemindsTranslate.json"></i18n>

<template>
	<div class="remind-config">
		<div class="flex justify-between items-center mb-4">
			<div class="w-1/6 flex flex-col">
				<vs-radio :vs-name="`remind-period-${formName}`" v-model="localRemind.period_type" :vs-value="1">{{ $t("ReminderBefore") }}</vs-radio>
				<vs-radio :vs-name="`remind-period-${formName}`" class="mt-4" v-model="localRemind.period_type" :vs-value="2">{{ $t("ReminderAfter") }}</vs-radio>
				<div></div>
			</div>
			<div class="w-2/6 flex items-center ">
				<cbs-input
					v-model="localRemind.value"
					class="w-2/5"
					:name="`${formName}-hour`"
					dataType="int"
					:maxlength="3"
					v-validate="{ regex: '^[1-9]\\d*$', required: true }"
					:data-vv-as="$t('Hour')"
					:placeholder="`${$t('Actions.Input')} ${$t('Hour')}`"
				/>
				<span class="ml-4">{{ $t("Hour") }}</span>
			</div>
			<div class="flex items-center">
				<span class="mr-4">{{ $t("From") }}</span>
				<el-select v-model="localRemind.milestone_type">
					<el-option v-for="item in milestones" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</div>
		</div>
		<span class="text-danger text-sm break-normal" v-show="errors.has(`${formName}-hour`)">{{ errors.first(`${formName}-hour`) }}</span>
		<!-- Description -->
		<!-- <p class="text-black">Công việc này sẽ được nhắc nhở vào lúc .</p> -->
		<div class="my-4 ">
			<label for class="vs-input--label">{{ $t("SendRemindTo") }}<span class="text-danger">*</span>:</label>

			<cbs-relations-humanroles
				class="w-full"
				:name="`${formName}-relations`"
				v-validate="'required'"
				v-model="localRemind.relations"
				:type="1"
				:close-on-select="false"
				:for="'people'"
				:placeholder="`${$t('Actions.Choose')} ${$t('ReceiverEmail').toLowerCase()}`"
				:data-vv-as="$t('ReceiverEmail')"
			/>
			<span class="text-danger text-sm" v-show="errors.has(`${formName}-relations`)">{{ errors.first(`${formName}-relations`) }}</span>
		</div>

		<!-- Block Remind content -->
		<div class="my-4">
			<label for class="vs-input--label">{{ $t("RemindContent") }}<span class="text-danger">*</span>:</label>
			<cbs-editor data-vv-delay="100" v-validate="'required'" class="bg-white normal-placeholder" v-model="localRemind.content" :name="`${formName}-content`" :data-vv-as="$t('RemindContent')" />
			<span class="text-danger text-sm break-normal" v-show="errors.has(`${formName}-content`)">{{ errors.first(`${formName}-content`) }}</span>
		</div>
		<!-- CC -->
		<div class="time-repeater--select-byhour">
			<label for class="vs-input--label">{{ $t("CarbonCopy") }}:</label>
			<el-select class="w-full" :no-data-text="$t('InputCCEmail')" v-model="localRemind.emails" multiple filterable allow-create :placeholder="$t('InputCCEmail')"> </el-select>
		</div>
		<div class="flex items-center justify-end">
			<vs-button radius type="flat" class="p-0" color="primary" icon-pack="nucleo" icon="nucleo-trash-can" @click="$emit('onClickDelete', localRemind)"></vs-button>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";
import vSelect from "vue-select";

import CbsEditor from "@/components/cbs-editor/CbsEditor";

const isValidRemindData = remind =>
	_.has(remind, "content") && _.has(remind, "emails") && _.has(remind, "relations") && _.has(remind, "value") && _.has(remind, "milestone_type") && _.has(remind, "period_type");

export default {
	name: "RemindConfig",
	inject: ["parentValidator"],
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => isValidRemindData(prop)
		},
		formName: {
			type: String,
			default: "remind-config"
		}
	},
	emits: {
		onClickDelete: {}
	},
	components: {
		vSelect,
		CbsEditor
	},
	data() {
		return {
			milestones: [
				{ label: this.$t("StartTime"), value: this.$constant.REMINDER.MILESTONE_TYPE.START_DATE },
				{ label: this.$t("Deadline"), value: this.$constant.REMINDER.MILESTONE_TYPE.DEADLINE_DATE }
			]
		};
	},
	computed: {
		localRemind: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss">
.remind-config {
	padding: 25px;
	border-radius: 4px;
	background: #f8f8f8;
}
</style>
